import { COVERT_PT_BR } from "#pages/place/settings/couvert/translations";
import { vendor } from "./vendor";

export const settings = {
	title: "Editar configurações",
	error: "Sem permissão para editar local",
	alterImage: "Imagem alterada com sucesso",
	attention: "Atenção!",
	url: "nomedoproduto",
	daysAndWorkingPeriod: "Dias e horário de funcionamento",
	address: {
		postalCode: "CEP",
		state: "Estado",
		city: "Cidade",
		neighborhood: "Bairro",
		address: "Rua",
		number: "Número",
		complement: "Complemento",
		placeholders: {
			state: "Ex.: SP",
			city: "Ex.: São Paulo",
			neighborhood: "Ex.: Centro",
			address: "Ex.: Av. Paulista",
			number: "Ex.: 60",
			complement: "Ex.: Loja A",
		},
	},
	workingPeriod: {
		deletedPeriod: "Período deletado.",
		addDaysAndTime: "Adicionar dias e horários",
		addOpeningHours: "Adicionar horário de funcionamento",
		daysOfTheWeek: "Dias da semana",
		start: "Início",
		end: "Final",
	},
	menu: {
		title: "Outras opções de configuração",
		general: {
			title: "Gerais",
			subtitle: "Informe limite, e-mails e outros",
		},
		productsWeb: {
			title: "Produtos Web",
			subtitle: "Configure a vinculação de bar para delivery.",
		},
		record: {
			title: "Configuração de Fichas",
			subtitle: "Configure o modo ficha",
		},
		couvert: {
			title: "Couvert",
			subtitle: "Configure os valores de couverts",
		},
		features: {
			title: "Funcionalidades",
			subtitle: "Ative e desative funcionalidades",
		},
		pdv: {
			title: "PDV",
			subtitle: "Configure o ponto de venda",
		},
		vendor: {
			title: "Vendor",
			subtitle: "Configure taxas dos vendors",
		},
		totem: {
			title: "Totem",
			subtitle: "Personalize os totens de atendimento",
		},
		refundReason: {
			title: "Motivos de Estorno/Cancelamento",
			subtitle: "Configure os motivos para o PDV",
		},
		fiscalPrinter: {
			title: "Impressoras fiscais",
			subtitle: "Configure as impressoras fiscais do local",
		},
		deliveryFees: {
			title: "Taxas de delivery",
			subtitle: "Vincule taxas de delivery a grupos fiscais",
		},
	},
	productsWeb: {
		title: "Produtos Web",
		subtitle: "Configure o link e demais informações do Entregue Já e Pedido na Mesa.",
		saveChanges: "Salvar alterações",
		toastSuccess: "Configurações salvas com sucesso",
		toastError: "Não foi possível salvar as alterações. Por favor, tente novamente.",
		tabMenuPersonalization: "Personalização de cardápio",
		tabFichaDigital: "Ficha Digital",
		tabs: {
			personalization: "Personalização de cardápio",
			banners: "Banners",
			featured: "Destaque",
			barLink: "Vinculação de bar",
			deliveryFee: "Taxas de entrega",
		},
		fichaDigital: {
			heading: "Exibição de eventos no cardápio",
			subtitle: "Quais eventos devem aparecer neste cardápio?",
			sameDayLabel: "Mostrar apenas eventos deste dia",
			sameDayDescription:
				"Exibe somente os eventos que acontecem na mesma data do cardápio.",
			samePlaceLabel: "Mostrar todos os eventos deste local (place)",
			samePlaceDescription:
				"Exibe também eventos de outras datas vinculados ao mesmo local.",
			save: "Salvar Alterações",
			saving: "Salvando...",
			toastSuccess: "Configuração salva com sucesso",
			toastError: "Não foi possível salvar a configuração",
		},
		personalizationTab: {
			displayTitle: "Exibição",
			displayDescription:
				"Controle quais seções aparecem para os clientes nos cardápios digitais.",
			showBanners: "Mostrar banners",
		},
		featuredTab: {
			title: "Seção de destaque",
			description:
				"Monte a sugestão do dia do cardápio digital: escolha o título, ative a seção e organize os produtos em destaque na ordem desejada.",
			titleFieldLabel: "Título da seção",
			titleFieldPlaceholder: "Ex.: Sugestões do dia",
			titleFieldHelper: "Aparece como cabeçalho da seção no cardápio.",
			visibilityToggle: {
				label: "Mostrar seção de destaque",
				description: "Exibe a seção de destaque no cardápio.",
			},
			disabledNotice: {
				title: "Seção desativada",
				description:
					"A seção de destaque não aparece no cardápio. Suas alterações ficam salvas para quando você reativar.",
			},
			productsFieldLabel: "Produtos em destaque",
			productsFieldDescription:
				"Adicione os produtos e arraste para definir a ordem de exibição.",
			productsPlaceholder: "Buscar produto para adicionar...",
			productsSearchTooShort: "Digite ao menos 2 caracteres para buscar.",
			productsSearchLoading: "Buscando produtos...",
			productsSearchEmpty: "Nenhum produto encontrado.",
			productAdded: "Adicionado",
			emptyTitle: "Nenhum produto em destaque ainda",
			emptyDescription:
				"Busque acima e adicione os produtos que vão aparecer na seção de destaque.",
			reorderProduct: "Reordenar produto",
			removeProduct: "Remover produto",
			save: "Salvar alterações",
			saving: "Salvando...",
			toastSuccess: "Seção de destaque salva com sucesso",
			toastError: "Não foi possível salvar a seção de destaque. Tente novamente.",
			noMenuTitle: "Nenhum cardápio digital encontrado",
			noMenuDescription: "Crie um cardápio digital para configurar a seção de destaque.",
			languages: {
				ptBR: "Português",
				enUs: "Inglês",
				esMx: "Espanhol",
			},
		},
		bannersTab: {
			title: "Banners de campanha",
			description:
				"Crie e organize os banners exibidos no topo e entre as seções do cardápio digital. Arraste para reordenar.",
			visibilityToggle: {
				label: "Mostrar banners",
				description: "Exibe os banners de campanha no cardápio.",
				toastSuccess: "Exibição de banners atualizada",
				toastError: "Não foi possível atualizar a exibição de banners",
			},
			addBanner: "Adicionar banner",
			empty: {
				title: "Nenhum banner criado",
				description:
					"Crie banners de campanha para destacar promoções e novidades no cardápio digital.",
				action: "Adicionar banner",
			},
			slots: {
				hero: "Topo (destaque)",
				between_sections: "Entre seções",
			},
			status: {
				active: "Ativo",
				inactive: "Inativo",
			},
			card: {
				noTitle: "Sem título",
				edit: "Editar banner",
				delete: "Remover banner",
				dragHint: "Arraste para reordenar",
			},
			form: {
				createTitle: "Adicionar banner",
				editTitle: "Editar banner",
				image: "Imagem",
				imageHint: "Recomendamos 1280x720 (proporção 16:9), nos formatos .PNG ou .JPEG.",
				imageRequired: "A imagem é obrigatória.",
				title: "Título",
				titlePlaceholder: "Ex.: Combo de verão",
				subtitle: "Subtítulo",
				subtitlePlaceholder: "Ex.: Peça já e aproveite",
				linkUrl: "Link",
				linkUrlPlaceholder: "https://...",
				slot: "Posição",
				slotHero: "Topo (destaque)",
				slotBetweenSections: "Entre seções",
				targetType: "Direcionamento",
				targetNone: "Nenhum",
				targetProduct: "Produto",
				targetCategory: "Categoria",
				targetProductPlaceholder: "Selecione o produto",
				targetCategoryPlaceholder: "Selecione a categoria",
				startsAt: "Início",
				endsAt: "Término",
				isActive: "Banner ativo",
				cancel: "Cancelar",
				save: "Salvar",
				create: "Adicionar",
				discardTitle: "Descartar alterações?",
				discardDescription:
					"Este banner tem alterações não salvas. Se você sair agora, elas serão perdidas.",
				discardCancel: "Continuar editando",
				discardConfirm: "Descartar",
			},
			delete: {
				title: "Remover banner",
				descriptionPrefix: "Tem certeza que deseja remover o banner ",
				descriptionSuffix: "? Essa ação não pode ser desfeita.",
				fallbackName: "sem título",
				cancel: "Cancelar",
				confirm: "Remover",
			},
			toast: {
				createSuccess: "Banner criado com sucesso",
				editSuccess: "Banner atualizado com sucesso",
				deleteSuccess: "Banner removido com sucesso",
				reorderSuccess: "Ordem dos banners atualizada",
				error: "Não foi possível concluir a ação. Tente novamente.",
			},
		},
		qrcodeTab: {
			title: "QR Code",
			description: "Crie os QR Codes do seu cardápio digital aqui.",
			linkCardTitle: "Link do cardápio",
			configureLink: "Configure o slug do cardápio em Configurações",
			copyLink: "Copiar link",
			copySuccess: "Link copiado para a área de transferência",
			copyError: "Não foi possível copiar o link",
			generateButton: "Gerar QR Code",
			drawer: {
				title: "Gerar QR Code",
				modeSectionTitle: "Modo de criação",
				modeSingle: "QR Code único",
				modeBulk: "QR Code em massa",
				singleTitle: "Mesa",
				bulkTitle: "Mesas",
				singleDescription: "Defina a mesa para a qual o QR Code será gerado.",
				bulkDescription:
					"Defina o intervalo de mesas. Limite de {{max}} QR codes por vez.",
				parameterLabel: "Parâmetro",
				parameterPlaceholder: "Selecione um parâmetro",
				parameterTooltip: "Tipo de parâmetro usado para identificar a mesa.",
				parameterOptions: {
					table: "Mesa",
					chair: "Cadeira",
					room: "Quarto",
					reference: "Referência",
				},
				identificationLabels: {
					table: "Identificação da mesa",
					chair: "Identificação da cadeira",
					room: "Identificação do quarto",
					reference: "Identificação da referência",
					default: "Identificação",
				},
				identificationTooltip:
					"Digite o identificador para o qual o QR Code será gerado.",
				identificationPlaceholder: "Digite aqui a {{label}}",
				fromLabel: "De",
				fromTooltip: "Primeiro número da sequência.",
				toLabel: "Até",
				toTooltip: "Último número da sequência.",
				cancel: "Cancelar",
				submit: "Gerar QR Code",
				successToast:
					"QR Code(s) gerado(s) com sucesso. Em breve o download será iniciado.",
				errorToast: "Algo deu errado durante a criação, mas você pode tentar novamente",
				validation: {
					alphanumericOnly: "Apenas letras e números são aceitos",
					parameterRequired: "Selecione um parâmetro",
					fromRequired: "Informe o início do intervalo",
					toRequired: "Informe o fim do intervalo",
					toGreaterThanFrom: "Até deve ser maior ou igual a De",
					maxQuantity: "Limite máximo de {{max}} QR codes por vez",
				},
				discardDialog: {
					title: "Descartar alterações?",
					description:
						"Você tem alterações não salvas neste formulário. Se sair agora, elas serão perdidas.",
					cancel: "Continuar editando",
					confirm: "Descartar alterações",
				},
			},
		},
		generalTab: {
			urlLabel: "Endereço URL",
			urlSubtitle:
				"Defina o endereço url de acesso para o Cardápio digital, Entregue Já, Pedido na Mesa e Comanda Online.",
			slugInvalid: "O slug deve conter apenas letras, números, hífens e underscores",
			barLabel: "Bar para impressão",
			barSubtitle:
				"Vincule as integrações a um bar de segurança. Se algum pedido não for impresso no bar configurado da integração, ele é enviado para este bar.",
			selectBarLabel: "Selecione o bar",
			selectBarTooltip: "Só é possível vincular apenas um bar para todas as integrações",
			noInternalIpAlert: {
				message:
					"O bar selecionado não possui IP interno configurado. Os pedidos podem não ser impressos automaticamente.",
			},
			save: "Salvar Alterações",
		},
		deliveryFee: {
			title: "Taxas de entrega",
			subtitle: "Defina como a taxa de entrega será cobrada nos pedidos por delivery.",
			taxTypeLabel: "Tipo de cobrança",
			taxTypeOptions: {
				unique: "Taxa única",
				baseRateWithVariableKm: "Taxa base + valor por Km",
				ratePerRadius: "Valor por raio de atendimento",
			},
			baseRateValueLabel: "Taxa base",
			ratePerKmLabel: "Valor por Km",
			attendanceRadiusLabel: "Raio de atendimento",
			attendanceRadiusSuffix: "km",
			save: "Salvar Alterações",
		},
		brandingCrossLink: {
			text:
				"Estes valores herdam da identidade visual do estabelecimento. Para alterar o padrão, acesse",
			linkLabel: "Identidade Visual do Estabelecimento",
		},
	},
	warningDialog:
		"Você está habilitando pagamentos pós-pagos em '{{name}}'. " +
		"Você está certo disso? Para confirmar a modificação, " +
		"favor digitar '{{text}}'",
	data: {
		label: "Dados",
		name: "Nome",
		selectProduct: "Selecione um produto para habilitar depósito caução automático",
		noneProduct: "Nenhum produto",
		peopleCapacity: "Capacidade máxima",
		slug: "Slug",
		peopleCapacityTooltip: "Quantidade de pessoas que o local comporta.",
	},
	passTemplate: "ID do modelo do passe",
	limits: {
		label: "Limites e serviços",
		postPaidLimit: "Limite de pós-pago",
		serviceTax: "Taxa de serviço",
		rechargeNotIntegratedLimit: "Limite de recarga não integrada",
		nonIntegratedPaymentLimit: "Limite de pagamento não integrado por device e evento",
		enableBuiltInLimit: "Ativar limite de recarga não integrada",
		enableNonIntegratedPaymentLimit:
			"Ativar limite de pagamento não integrado por device e evento",
		nonIntegratedPaymentLimitTooltip:
			"Este limite se refere ao valor máximo de pagamentos não integrados " +
			"que um dispositivo pode receber durante o evento. Esse parâmetro é a soma " +
			"do total de Recargas e Vendas Sem Cartão feitos com pagamentos não integrados.",
		nonIntegratedRechargeLimitTooltip:
			"Este limite se refere ao valor máximo que um funcionário pode fazer em uma recarga não integrada.",
	},
	settings: {
		label: "Configurações",
		myActionsPassword: {
			label: "Senha do ¨Minhas ações¨",
			placeholder: "Insira uma senha numérica ou a senha padrão será 9090",
		},
		sellVisualizationFormat: {
			label: "Formato de visualização dos produtos na venda",
			grid: "Grade",
			list: "Lista",
		},
		kdsServer: {
			label: "IP do servidor KDS",
			placeholder: "Digite o IP",
		},
	},
	everest: {
		label: "Everest",
		user: "Usuário",
		password: "Senha",
		cnpj: "CNPJ",
		host: "Host",
	},
	placeFeatures: "Funcionalidades",
	email: "E-mails para recebimento do fechamento dos eventos",
	emailError: "Email inválido",
	consumption: {
		label: "Configuração fiscal de consumação mínima",
		fiscalProfile: "Perfil fiscal",
		fiscalGroup: "Grupo fiscal",
		ncm: "NCM",
	},
	alert: "Modificações foram realizadas, salve para mantê-las",
	save: "Salvar",
	saveSettings: "Salvar configurações",
	image: "Foto",
	ficha: {
		label: "Ficha",
		text: "Título da Ficha",
		placeholderText: "Insira o título da ficha",
		logo: "Imagem na ficha",
		upload: "Anexar imagem",
		formatError: "Formato não suportado",
		imageFormatMessage: "É necessário que a imagem seja um PNG ou SVG.",
		recommendationMessage:
			"Recomendamos que a imagem atribuída seja o <strong>logo</strong> da empresa na <strong>cor preta</strong>, uma vez que não é possível realizar a impressão de outra cor.",
		dragOrSelectMessage:
			"Arraste a imagem do computador ou selecione a partir de 'Anexar imagem'.",
		logoFormatMessage:
			"É necessário que o <strong>fundo da imagem/logo esteja branco</strong>, para que fique transparente na impressão.",
		dimensionsMessage:
			"As dimensões sugeridas para uma boa resolução são as de <strong>472x472</strong> px.",
		size: {
			Small: "P - Pequeno",
			Medium: "M - Médio",
			Large: "G - Grande",
			NoImage: "Sem Imagem",
			NoQRCode: "Sem QRCode",
			recommend: "recomendado",
		},
		fontSize: "Tamanho da fonte",
		imageSize: "Imagem",
		qrCodeSize: "Tamanho do QR Code",
	},
	couvertEdit: COVERT_PT_BR,
	devices: {
		label: "PDVs do local ({{counter}})",
		placeholder: "Adicionar um PDV a esse local",
		requestDevices: "Solicitar equipamentos",
	},
	errors: {
		invalidName: "Insira um nome válido",
		invalidTip: "Insira um valor de até 25%",
		postPaidLimit: "Insira um valor válido",
		rechargeNotIntegratedLimit: "Valor mínimo de",
		hasConsumptionObligation:
			"Campo obrigatório para configuração de obrigação de consumo",
		minNonIntegratedPaymentLimit: "Valor mínimo de {{value}}",
		tipOptionsValuesRequired: "Os valores das gorjetas são necessários",
		tipOptionLowerValue: 'O "Valor menor" deve ser menor que os valores médio e maior',
		tipOptionHigherValue: 'O "Valor maior" deve ser maior do que o valor médio',
		invalidUrl: "Insira uma URL válida (https://...)",
		invalidCep: "CEP inválido. Informe 8 dígitos.",
		requiredAddressField: "Campo obrigatório quando o endereço está preenchido",
		cepLookupFailed: "Não foi possível consultar o CEP. Preencha manualmente.",
	},
	totem: {
		logoSelectDescription:
			"<strong>Selecione o logo que melhor se aplica na sua imagem</strong> (desconsidere a cor de fundo)",
		addLogo: "Adicionar",
		important: "Importante",
		instructions: "Recomendações",
		image: "A imagem deve ter  as dimensões de <strong>1080 x 1920</strong> px de altura",
		logo:
			"O logo da <strong>Zig</strong> aparecerá sobre a imagem atribuída, centralizado na parte superior",
		recomendations:
			"É recomendado inserir a mensagem <strong>'toque para iniciar'</strong> para orientar o usuário",
		defaultMessage:
			"Caso não adicione uma imagem de tela inicial, " +
			"a tela padrão da Zig será a sua tela inicial " +
			"(vide primeira imagem em “Cores”)",
		totemImgLabel: "Imagem da tela inicial (opcional)",
		totenCustomizationLabel: "Personalização Totem Ficha",
		removeTotemImage: {
			title: "Deseja excluir a tela inicial?",
			content: "Ao excluir, a tela inicial volta a ser a tela padrão da Zig.",
			confirmBtn: "Sim, quero excluir",
			cancelBtn: "Não",
		},
		colors: "Cores",
		saveMessage: "Salvar personalização",
	},
	tip: {
		taxType: "Tipo de taxa",
		tip: "Gorjeta",
		tipSuggestions: "Sugestões de gorjeta",
		serviceTax: "Taxa de serviço",
		none: "Sem taxa",
		lowerValue: "Valor menor",
		medValue: "Valor médio",
		higherValue: "Valor maior",
		tooltip:
			"As recomendações de gorjeta tornam o pagamento de conta mais fácil, " +
			"oferecendo três opções de porcentagens (Menor, Média e Maior) com base " +
			"no valor total da conta, por exemplo: 5%, 10% e 15% limitado a 25%",
	},
	authKeysFeature: {
		phone: "Telefone",
		email: "E-mail",
		keySelectLabel: "Escolha o tipo de chave",
		addKey: "Adicionar Chaves de autenticação",
		contactsInputLabel: "Adicione uma ou mais chaves para autenticação",
		contactsEmailInputPlaceholder: "Digite um email válido (ex: nomedoemail@gmail.com)",
		contactsPhoneInputPlaceholder:
			"Digite um número de telefone (ex: +55 (00) 0 00000000",
		btnAddKey: "Adicionar chaves de autenticação",
		btnCancelAddKey: "Cancelar",
		authKeyAreaTitle: "Autenticação de saque",
		authKeyAreaSubtitle:
			"Cadastre chaves (e-mail ou telefone) que serão usadas para receber o código de	autenticação ao solicitar um saque.",
		selectContactKeyMessage: "Selecione um tipo de chaves",
		selectContactInputMessage: "Preeencha uma chave de contato",
		contactAlreadyExists: "Esse contato já existe!",
		invalidEmail: "E-mail inválido",
		invalidPhone: "Telefone inválido. Deve conter DDI (ex: +5511999999999)",
		incompletePhone: "Número de telefone incompleto. Digite todos os dígitos.",
		invalidDDI:
			"Apenas números brasileiros são aceitos. Use o DDI +55 ou deixe em branco.",
		errorCreatingAuthKeys: "Erro ao criar chaves de autenticação",
		invalidContactsFound:
			"Contatos inválidos encontrados. Verifique os dados e tente novamente.",
		errorCreatingSomeKeys: "Erro ao criar algumas chaves: {{errors}}",
	},
	vendor,
	invoiceMoment: {
		fieldLabel: "Selecione o momento para emissão de Fatura cashless",
		tip:
			"Selecione o momento da emissão da fatura para pagamentos Cashless. Para todas as outras formas de pagamento, que não sejam Cashless, a fatura será sempre emitida no momento do consumo.",
		recharge: "Recarga",
		rechargeAndActivation: "Recarga e ativação",
		consumption: "Consumo",
		consumptionAndActivation: "Consumo e ativação",
	},
	refundReason: {
		addReason: "Criar motivo",
		cancel: "Cancelamento",
		modalDelete: {
			confirmation: "Deseja remover da lista de motivos de estornos e cancelamento?",
			description:
				"Ao remover o motivo não aparecerá mais, mas permanecerá nos relatórios antigos.",
			title: "Remover motivo de estorno/cancelamento",
		},
		modalForm: {
			addReason: "Criar Motivo",
			allowOpenText: "Habilitar justificativa",
			creatingReason: "Criando um motivo",
			editReason: "Salvar alterações",
			editingReason: "Editando um motivo",
			reason: "Motivo",
			reasonPlaceholder: "Digite o motivo de estorno e/ou cancelamento",
		},
		reason: "Motivo",
		removeReason: "Editar motivo",
		refund: "Estorno",
		table: {
			cancel: "Cancelamento",
			editReason: "Editar motivo",
			observation: "Observação",
			reason: "Motivo",
			refund: "Estorno",
			removeReason: "Remover motivo",
			status: "Status",
		},
		title: "Motivos de Estorno/Cancelamento",
	},
	fiscalPrinter: {
		title: "Impressoras fiscais",
		name: "Nome",
		type: "Tipo",
		ip: "Ip",
		actions: "Ações",
		deletedSuccessfully: "Impressora deletada com sucesso",
		addedSuccessfully: "Impressora adicionada com sucesso",
	},
	deliveryFees: {
		title: "Taxas de delivery",
		description:
			"Vincule cada taxa de delivery a um grupo fiscal para definir o tratamento na emissão da NF.",
		selectPlaceholder: "Selecione um grupo fiscal",
		emptyState: "Nenhuma taxa de delivery disponível.",
		saveSuccess: "Vínculo fiscal salvo com sucesso.",
		removeSuccess: "Vínculo fiscal removido com sucesso.",
		invoice: {
			included: "Entra na NF",
			excluded: "Fora da NF",
		},
		columns: {
			name: "Taxa",
			description: "Descrição",
			issueInvoice: "Emissão",
			fiscalGroup: "Grupo fiscal",
		},
		feeNames: {
			serviceFee: "Taxa de serviço",
			minimumOrderFee: "Taxa de pedido mínimo",
		},
	},
	defaultDateFilter: "Filtro de data padrão",
	pageHeader: {
		title: "Configurações gerais",
		description:
			"Adicione informações sobre o seu estabelecimento que serão visualizadas pelos clientes finais",
	},
	sections: {
		comingSoon: "Em breve",
		brand: {
			title: "Informações da marca",
			description:
				"Adicione informações da marca como logo, nome e slug (link url). Essas informações serão públicas e exibidas nos cardápios digitais.",
			addPhoto: "Adicionar foto",
			fileHint: "Tipo de arquivo PNG ou JPEG.",
		},
		payments: {
			title: "Pagamento e Taxas",
			description: "Informe limites de pagamento, taxas de gorjeta e outros.",
		},
		socialMedia: {
			title: "Redes Sociais",
			description:
				"Iremos exibir suas redes sociais nas informações sobre o estabelecimento nos cardápios digitais.",
			titleTooltip: "Copie e cole o link das redes sociais do estabelecimento",
			facebookLabel: "Facebook",
			instagramLabel: "Instagram",
			linkPlaceholder: "Cole o link do perfil do estabelecimento",
		},
		workingHours: {
			title: "Horário de funcionamento",
			description:
				"Os dias e horários de funcionamento do estabelecimento irão aparecer no cardápio digital quando definidos.",
		},
		event: {
			title: "Informações para evento",
			description:
				"Informe e-mail de contato do estabelecimento, número de telefone e capacidade máxima do estabelecimento.",
			emailLabel: "E-mails para recebimento do fechamento de eventos",
		},
		address: {
			title: "Endereço do estabelecimento",
			description:
				"Defina o endereço do estabelecimento, será exibido nas informações sobre o estabelecimento nos cardápios digitais.",
		},
	},
};
